// Story mode (?story=1): when a character joins with saved story progress, ask once whether to continue or restart.
// DOM overlay only; the world never pauses. "Restart story" sends {t:'story', op:'reset'}; the server clears only the
// story progress (no money, items, cred or XP).
import { esc } from './menus/kit';

export class StoryPopup {
  private el: HTMLDivElement;
  visible = false;
  constructor(private reset: () => void) {
    this.el = document.createElement('div'); this.el.id = 'storycard'; this.el.setAttribute('role', 'dialog'); this.el.setAttribute('aria-label', 'Story progress found');
    this.el.innerHTML = `<h3>${esc('Story progress found')}</h3><p>${esc('Pick up where you left off, or start the story again from the first step. Your money, gear and cred stay as they are.')}</p>
      <div class="b"><button data-story="restart">Restart story</button><button data-story="continue" class="go">Continue <span class="dim">(Enter)</span></button></div>`;
    document.body.appendChild(this.el);
    this.el.addEventListener('click', e => {
      const b = (e.target as HTMLElement).closest('button'); if (!b) return;
      this.close(b.dataset.story === 'restart');
    });
    addEventListener('keydown', e => {
      if (!this.visible || (e.code !== 'Enter' && e.code !== 'Escape')) return;
      e.preventDefault(); e.stopPropagation(); this.close(false);
    }, true);
  }
  show() { if (this.visible) return; this.visible = true; this.el.style.display = 'block'; this.el.querySelector<HTMLButtonElement>('.go')?.focus(); }
  private close(restart: boolean) { if (!this.visible) return; this.visible = false; this.el.style.display = 'none'; if (restart) this.reset(); }
}